import React from 'react';
import { View, StyleSheet } from 'react-native';
import {
  SkeletonGroup,
  SkeletonBone,
  SkeletonList,
  SkeletonListItem,
} from '@/components/common/skeleton';

export const ConversationListSkeleton: React.FC = () => (
  <SkeletonGroup style={styles.container}>
    {/* Search bar placeholder */}
    <SkeletonBone width="100%" height={40} borderRadius={20} />

    {/* Conversation items */}
    <SkeletonList count={6} gap={0}>
      <View style={styles.itemContainer}>
        <SkeletonListItem
          avatar
          avatarSize={48}
          lines={2}
          lineWidths={[140, 200]}
          lineHeight={14}
        />
      </View>
    </SkeletonList>
  </SkeletonGroup>
);

const styles = StyleSheet.create({
  container: {
    padding: 16,
    gap: 16,
  },
  itemContainer: {
    paddingVertical: 12,
  },
});
